import { gql } from '@apollo/client';

export const UPDATE_PROMPT = gql`
  mutation UpdatePrompt(
    $where: PromptUniqueFilterInput!
    $data: PromptUpdateInput!
  ) {
    updatePrompt(where: $where, data: $data) {
      body
    }
  }
`;
